import { render, staticRenderFns } from "./envia-especie.vue?vue&type=template&id=df2786fa&scoped=true"
import script from "./envia-especie.vue?vue&type=script&lang=js"
export * from "./envia-especie.vue?vue&type=script&lang=js"
import style0 from "./envia-especie.vue?vue&type=style&index=0&id=df2786fa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2786fa",
  null
  
)

export default component.exports